import { breadcrumbSlot } from "@redotech/arbiter/breadcrumb";

/** The policy name as the editor page's last breadcrumb. */
export const policyEditorBreadcrumb = breadcrumbSlot();
